var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "about"
  }, [_c("div", {
    staticClass: "background-video-container"
  }, [_c("video", {
    staticClass: "background-video",
    attrs: {
      muted: "",
      autoplay: "",
      loop: "",
      playsinline: "",
      preload: "auto",
      id: "background-video",
      poster: _vm.$whitelabel.productionS3RootUrl + "/images/landing/background_video_poster.jpg"
    },
    domProps: {
      muted: true
    }
  }, [_c("source", {
    attrs: {
      src: _vm.$whitelabel.productionS3RootUrl + "/hero_video_stabilized.mp4",
      type: "video/mp4"
    }
  })]), _c("div", {
    staticClass: "overlay"
  })]), _c("div", {
    staticClass: "hero-section"
  }, [_c("div", {
    staticClass: "overlay"
  }, [_vm._m(0), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSecondContent,
      expression: "showSecondContent"
    }],
    staticClass: "overlay-content-2"
  }, [_vm._m(1), _c("div", {
    staticClass: "email-input-container"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.emailAddress,
      expression: "emailAddress"
    }],
    staticClass: "email-input",
    attrs: {
      type: "email",
      placeholder: "Your email address"
    },
    domProps: {
      value: _vm.emailAddress
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.emailAddress = $event.target.value;
      }
    }
  }), _c("router-link", {
    attrs: {
      to: _vm.getSubscribeRoute()
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var href = _ref.href,
          route = _ref.route,
          navigate = _ref.navigate;
        return [_c("button", {
          staticClass: "submit-button",
          on: {
            click: navigate
          }
        }, [_c("svg", {
          attrs: {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        }, [_c("path", {
          attrs: {
            d: "M5 12H19M19 12L12 5M19 12L12 19",
            stroke: "currentColor",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })])])];
      }
    }])
  })], 1), _c("p", {
    staticClass: "disclaimer-text"
  }, [_vm._v(" BY SUBSCRIBING YOU ACCEPT OUR "), _c("router-link", {
    staticClass: "underlined-link",
    attrs: {
      to: _vm.goToTermsOfSales()
    }
  }, [_vm._v(" TERMS & CONDITIONS ")]), _vm._v(" & "), _c("router-link", {
    staticClass: "underlined-link",
    attrs: {
      to: _vm.goToTermsOfUse()
    }
  }, [_vm._v("PRIVACY POLICY")]), _vm._v(" . "), _c("span", {
    staticClass: "line-break"
  }), _vm._v(" YOU CAN UNSUBSCRIBE AT ANY TIME. ")], 1)])]), _c("button", {
    staticClass: "scroll-button",
    on: {
      click: _vm.scrollToFirstSection
    }
  }, [_c("svg", {
    attrs: {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }
  }, [_c("path", {
    attrs: {
      d: "M12 4L12 17M12 17L6 11M12 17L18 11",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])]), _c("section", {
    staticClass: "about-section-1"
  }, [_c("div", {
    staticClass: "parallax-video-container left-image"
  }, [_c("video", {
    staticClass: "parallax-video",
    attrs: {
      muted: "",
      autoplay: "",
      loop: "",
      playsinline: "",
      preload: "auto"
    },
    domProps: {
      muted: true
    }
  }, [_c("source", {
    attrs: {
      src: _vm.$whitelabel.productionS3RootUrl + "/videos/landing/landing_video_01.mp4",
      type: "video/mp4"
    }
  })])]), _vm._m(2)]), _c("section", {
    staticClass: "about-section-2"
  }, [_c("div", {
    staticClass: "parallax-video-container right-image"
  }, [_c("video", {
    staticClass: "parallax-video",
    attrs: {
      muted: "",
      autoplay: "",
      loop: "",
      playsinline: "",
      preload: "auto"
    },
    domProps: {
      muted: true
    }
  }, [_c("source", {
    attrs: {
      src: _vm.$whitelabel.productionS3RootUrl + "/videos/landing/landing_video_02.mp4",
      type: "video/mp4"
    }
  })])]), _vm._m(3)]), _c("section", {
    staticClass: "about-section-3"
  }, [_c("div", {
    staticClass: "parallax-video-container left-image"
  }, [_c("video", {
    staticClass: "parallax-video",
    attrs: {
      muted: "",
      autoplay: "",
      loop: "",
      playsinline: "",
      preload: "auto"
    },
    domProps: {
      muted: true
    }
  }, [_c("source", {
    attrs: {
      src: _vm.$whitelabel.productionS3RootUrl + "/videos/landing/landing_video_03.mp4"
    }
  })])]), _vm._m(4)]), _c("section", {
    staticClass: "about-section-5"
  }, [_c("div", {
    staticClass: "title-container"
  }, [_c("router-link", {
    attrs: {
      to: {
        name: "cellarJournal"
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var href = _ref2.href,
          route = _ref2.route,
          navigate = _ref2.navigate;
        return [_c("h2", {
          staticClass: "title",
          on: {
            click: navigate
          }
        }, [_vm._v("The Cellar Journal")])];
      }
    }])
  }), _c("h3", {
    staticClass: "subtitle"
  }, [_vm._v(" In-depth insights into the world of fine wine, exploring the stories, craftsmanship, & traditions that shape it. ")])], 1), _c("div", {
    staticClass: "section-content"
  }, [_c("div", {
    staticClass: "cards-container"
  }, [_vm._l(_vm.posts, function (post) {
    return _c("div", {
      key: post.slug,
      staticClass: "card"
    }, [_c("div", {
      staticClass: "card-content"
    }, [_c("router-link", {
      attrs: {
        to: {
          name: "cellarJournalDetail",
          params: {
            slug: post.slug
          }
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref3) {
          var href = _ref3.href,
            route = _ref3.route,
            navigate = _ref3.navigate;
          return [_c("img", {
            staticClass: "card-image",
            attrs: {
              src: _vm.urlForImage(post.mainImage).width(2000).url(),
              alt: "Wine Highlight"
            },
            on: {
              click: navigate
            }
          })];
        }
      }], null, true)
    }), _c("h3", {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(post.title))]), _c("p", {
      staticClass: "card-description"
    }, [_vm._v(" " + _vm._s(post.briefDescription) + " ")])], 1), _c("router-link", {
      attrs: {
        to: {
          name: "cellarJournalDetail",
          params: {
            slug: post.slug
          }
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref4) {
          var href = _ref4.href,
            route = _ref4.route,
            navigate = _ref4.navigate;
          return [_c("button", {
            staticClass: "card-button",
            on: {
              click: navigate
            }
          }, [_vm._v("DISCOVER " + _vm._s(post.shortTitle))])];
        }
      }], null, true)
    })], 1);
  }), _c("div", {
    staticClass: "empty-card"
  }, [_c("router-link", {
    attrs: {
      to: {
        name: "cellarJournal"
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var href = _ref5.href,
          route = _ref5.route,
          navigate = _ref5.navigate;
        return [_c("button", {
          staticClass: "empty-card-button",
          on: {
            click: navigate
          }
        }, [_vm._v(" Access the "), _c("br"), _vm._v(" Cellar Journal ")])];
      }
    }])
  })], 1)], 2)])]), _c("section", {
    staticClass: "about-section-4"
  }, [_c("router-link", {
    attrs: {
      to: {
        name: "login"
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var href = _ref6.href,
          route = _ref6.route,
          navigate = _ref6.navigate;
        return [_c("button", {
          staticClass: "about-button",
          on: {
            click: navigate
          }
        }, [_vm._v("EXPLORE CLOS & MONOPOLE")])];
      }
    }])
  })], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "overlay-content-1"
  }, [_c("img", {
    staticClass: "logo",
    attrs: {
      src: require("@/assets/images/c&m_full_logo_white.png"),
      alt: "Wine Highlight"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("h2", [_vm._v(" Join a world of "), _c("span", {
    staticClass: "mobile-break"
  }, [_c("br")]), _vm._v(" Fine Wine ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section-content scroll-fade-element"
  }, [_c("p", {
    staticClass: "section-text right"
  }, [_vm._v(" Clos & Monopole is redefining access to exceptional wines in major export markets, while giving producers greater control over their export processes & distribution. "), _c("br"), _c("br"), _vm._v(" Our platform offers wine enthusiasts & industry professionals access to the world's most sought-after wineries & Ex-Domaine wines, supported by direct import, global leading solutions, integrated logistics & customs clearance in over 120+ countries. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section-content scroll-fade-element"
  }, [_c("p", {
    staticClass: "section-text left"
  }, [_vm._v(" Easily access local events, orders, shipments and tracking while managing payments, and allocations. "), _c("br"), _c("br"), _vm._v(" Gain a clear overview of your collection and inventory, receive low-stock alerts, monitor global availability, and track sales with monthly reports and personal notes. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section-content scroll-fade-element"
  }, [_c("p", {
    staticClass: "section-text right"
  }, [_vm._v(" Be part of unique experiences & immersions in partnership with leading producers, sommeliers & Chefs globally, offering a rare opportunity to explore exceptional producers and talents, in an atmosphere of elegance, connection & discovery. "), _c("br"), _c("br"), _vm._v(" Benefit from global wine market expertise & wine program consultancy services. ")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };